import './reel.css'
import './web_component'
import React from 'react'
import { ReelLayoutProps } from './types'

export const Reel: React.FC<ReelLayoutProps> = ({ children, ...props }) => <reel-l {...props}>{children}</reel-l>
